import {
    Autowired,
    ColDef,
    ColGroupDef,
    Column,
    Component,
    IMenuFactory,
    RefSelector,
    UserComponentRegistry,
} from "ag-grid-community";
import { HeaderComp } from "ag-grid-community/dist/lib/headerRendering/cells/column/headerComp";
import {
    HeaderGroupComp,
    IHeaderGroupParams,
} from "ag-grid-community/dist/lib/headerRendering/cells/columnGroup/headerGroupComp";
import { MENU_GENERAL_TAB_ONLY } from "helpers/door-collection";
const holder = {};
UserComponentRegistry.apply(holder);
// @ts-ignore
const _HeaderGroupComp = (holder as UserComponentRegistry).agGridDefaults.agColumnGroupHeader as {
    new (): HeaderGroupComp;
};
// @ts-ignore
const _HeaderComp = (holder as UserComponentRegistry).agGridDefaults.agColumnHeader as { new (): HeaderComp };

interface HeaderCompWithMenuParams extends IHeaderGroupParams {
    column: Column;
    enableMenu: boolean;
}
export class HeaderCompWithMenu extends _HeaderGroupComp {
    static TEMPLATE = `<div class="ag-header-group-cell-label" ref="agContainer" role="presentation">
            <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
            <span ref="agLabel" class="ag-header-group-text" role="presentation"></span>
            <span ref="agOpened" class="ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded"></span>
            <span ref="agClosed" class="ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed"></span>
        </div>`;

    @Autowired("menuFactory") private menuFactory: IMenuFactory;
    @RefSelector("eMenu") private eMenu: HTMLElement;
    private column: Column;
    constructor() {
        super();
        Component.call(this, HeaderCompWithMenu.TEMPLATE);
    }

    private workOutShowMenu() {
        return true;
    }

    public init(params: IHeaderGroupParams) {
        const { columnGroup } = params;
        const colDef: ColDef | ColGroupDef = Object.assign(
            { colId: columnGroup.getGroupId(), menuTabs: MENU_GENERAL_TAB_ONLY },
            columnGroup.getColGroupDef()
        );
        this.column = new Column(colDef, colDef, columnGroup.getGroupId(), false);

        // @ts-ignore
        this.eMenu.append(this.createMenuIcon());
        super.init({ ...params, enableMenu: true, column: this.column } as HeaderCompWithMenuParams);
        // @ts-ignore
        _HeaderComp.prototype.setMenu.call(this);
        Promise.resolve().then(() => {
            this.getGui()?.parentElement?.addEventListener("mouseenter", this.setIsHeaderActive);
            this.getGui()?.parentElement?.addEventListener("mouseleave", this.unsetIsHeaderActive);
        });
    }

    private createMenuIcon() {
        const span = document.createElement("span");
        span.setAttribute("class", "ag-icon ag-icon-menu");
        span.setAttribute("unselectable", "on");
        span.setAttribute("role", "presentation");

        return span;
    }

    private setHeaderActive(active: boolean) {
        this.getGui().parentElement?.classList.toggle("ag-header-active", active);
    }

    private setIsHeaderActive = () => {
        this.setHeaderActive(true);
    };
    private unsetIsHeaderActive = () => {
        this.setHeaderActive(false);
    };

    public destroy() {
        this.getGui()?.removeEventListener("focusin", this.setIsHeaderActive);
        this.getGui()?.removeEventListener("focusout", this.unsetIsHeaderActive);

        this.getGui()?.parentElement?.removeEventListener("mouseenter", this.setIsHeaderActive);
        this.getGui()?.parentElement?.addEventListener("mouseleave", this.unsetIsHeaderActive);
    }

    public showMenu = _HeaderComp.prototype.showMenu;
}
